import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { MONTHS, YEARS } from "./SalesPeriodBar";

export const AWARD_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "awarded", label: "Awarded" },
  { value: "partially_awarded", label: "Partially Awarded" },
  { value: "lost", label: "Lost" },
];

export const EMPTY_EST_FILTERS = { search: "", client: "", salesperson: "", award: "", year: "", month: "" };

const FilterSelect = ({ label, value, onChange, allLabel, options, testId, disabled }) => (
  <div>
    <label className="block text-xs text-gray-600 font-medium mb-1">{label}</label>
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)} disabled={disabled}>
      <SelectTrigger data-testid={testId} className="bg-white border-gray-300"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{allLabel}</SelectItem>
        {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

const has = (text, term) => (text || "").toLowerCase().includes(term.trim().toLowerCase());

export const applyEstFilters = (rows, f) => rows.filter((r) =>
  (!f.search.trim() || has(r.estimation_number, f.search)) &&
  (!f.client.trim() || has(r.client_name, f.client) || has(r.client_number, f.client)) &&
  (!f.salesperson.trim() || has(r.sales_person_name, f.salesperson)) &&
  (!f.award || (r.award_status || "pending") === f.award) &&
  (!f.year || (r.submitted_date || "").startsWith(f.month ? `${f.year}-${String(f.month).padStart(2, "0")}` : f.year))
);


const SearchBox = ({ label, value, onChange, placeholder, testId }) => (
  <div>
    <label className="block text-xs text-gray-600 font-medium mb-1">{label}</label>
    <div className="relative">
      <Search className="h-4 w-4 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2" />
      <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="pl-8 bg-white border-gray-300" data-testid={testId} />
    </div>
  </div>
);

export const EstimationListFilters = ({ rows, filters, setFilters }) => {
  const set = (k) => (v) => setFilters({ ...filters, [k]: v, ...(k === "year" && !v ? { month: "" } : {}) });
  return (
    <div className="grid grid-cols-1 md:grid-cols-7 gap-3 mb-5 items-end" data-testid="sales-est-filters">
      <SearchBox label="Estimation #" value={filters.search} onChange={set("search")} placeholder="e.g. 26ES0797" testId="est-filter-search" />
      <SearchBox label="Client" value={filters.client} onChange={set("client")} placeholder="Search by number or name..." testId="est-filter-client" />
      <SearchBox label="Salesperson" value={filters.salesperson} onChange={set("salesperson")} placeholder="Search by name..." testId="est-filter-salesperson" />
      <FilterSelect label="Award Status" value={filters.award} onChange={set("award")} allLabel="All Statuses" options={AWARD_STATUSES} testId="est-filter-award" />
      <FilterSelect label="Submitted Year" value={filters.year} onChange={set("year")} allLabel="All Years" options={[...new Set([...YEARS.map(String), ...rows.map((r) => (r.submitted_date || "").slice(0, 4)).filter((y) => /^\d{4}$/.test(y))])].sort().reverse().map((y) => ({ value: y, label: y }))} testId="est-filter-year" />
      <FilterSelect label="Submitted Month" value={filters.month} onChange={set("month")} allLabel="All Months" disabled={!filters.year} options={MONTHS.map((m, i) => ({ value: String(i + 1), label: m }))} testId="est-filter-month" />
      <Button variant="outline" onClick={() => setFilters(EMPTY_EST_FILTERS)} data-testid="est-filter-clear" className="rounded-md3-full">
        Clear Filters
      </Button>
    </div>
  );
};
